/**
 * Slim top-of-panel progress bar used anywhere data is still being
 * assembled: the first map build, group tracing, a slow fetch. `progress`
 * 0-1 draws a real bar; omitted/undefined draws an animated indeterminate
 * one so there is always visible motion, never a dead screen.
 */
export function LoadingBar({ progress, label }: { progress?: number; label?: string }) {
  const pct = progress === undefined ? undefined : Math.max(0.03, Math.min(1, progress));
  return (
    <div className="loadbar" role="progressbar" aria-valuenow={pct !== undefined ? Math.round(pct * 100) : undefined}>
      <div className={`loadbar-track ${pct === undefined ? 'indet' : ''}`}>
        <div className="loadbar-fill" style={pct !== undefined ? { width: `${pct * 100}%` } : undefined} />
      </div>
      {label && (
        <div className="loadbar-label">
          {label}
          {pct !== undefined && <b> {Math.round(pct * 100)}%</b>}
        </div>
      )}
    </div>
  );
}
